
import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AuthContext } from '../state/auth';
import { ErrorContext } from '../state/error';
import { ToastContainer, toast } from 'react-toastify';

import PrivateRoute from './private-route';
import Login from '../containers/login';
import Logout from '../containers/login/logout';
import ForgotPass from '../containers/login/forgot';
import RegisterUser from '../containers/login/register';
import DashBoard from '../containers/dashboard';
import AdminUsers from '../containers/adminUsers';
import Users from '../containers/users';
import UserShipments from '../containers/users/user-shipments';
import UserTrips from '../containers/users/user-trips';
import Offers from '../containers/offers';
import Trips from '../containers/trips';
import MatchedShipments from '../containers/trips/matchedShipments';
import Shipments from '../containers/shipments';
import Products from '../containers/products';
import Stores from '../containers/products/stores/index';
import Countries from '../containers/countries';
import Cities from '../containers/countries/cities';
import Stories from '../containers/countries/stories/index';
import Reports from '../containers/reports';
import Settings from '../containers/settings';
import Faq from '../containers/settings/faq';
import Categories from '../containers/products/categories/index';
import SubCategories from '../containers/products/subCategories';
import Notifications from '../containers/notifications';
import Pricing from '../containers/pricing';
import Message from '../containers/message';

const Root = props => {
  const existingTokens = JSON.parse(localStorage.getItem("tokens"));
  const [authTokens, setAuthTokens] = useState(existingTokens);
  const [isError, setIsError] = useState(false);

  const setTokens = (data) => {
    localStorage.setItem("tokens", JSON.stringify(data));
    setAuthTokens(data);
  }

  const setErrors = (msg, type = 'error') => {
    setIsError(msg);
    console.log(msg)
    if (type === 'success') {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
  }

  return (
    <ErrorContext.Provider value={{ isError, setIsError: setErrors }}>
      <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
        <Router>
          <>
            <ToastContainer />
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/forgot" component={ForgotPass} />
              <Route exact path="/signup" component={RegisterUser} />

              <PrivateRoute path="/home" component={DashBoard} />
              <PrivateRoute path="/admins" component={AdminUsers} />
              <PrivateRoute path="/users/userShipments/:id" component={UserShipments} />
              <PrivateRoute path="/users/userTrips/:id" component={UserTrips} />
              <PrivateRoute path="/users" component={Users} />
              <PrivateRoute path="/notifications" component={Notifications} />
              <PrivateRoute path="/pricing" component={Pricing} />
              <PrivateRoute path="/message" component={Message} />

              <PrivateRoute path="/offers" component={Offers} />
              <PrivateRoute path="/trips/tripShipments/:id" component={MatchedShipments} />
              <PrivateRoute path="/trips" component={Trips} />
              
              <PrivateRoute path="/shipments" component={Shipments} />

              <PrivateRoute path="/products/stores" component={Stores} />
              <PrivateRoute exact path="/products/categories" component={Categories} />
              <PrivateRoute path="/products/categories/:id/subcategories" component={SubCategories} />
              <PrivateRoute path="/products" component={Products} />
              <PrivateRoute path="/countries/stories" component={Stories} />
              <PrivateRoute path="/countries/cities/:id" component={Cities} />
              <PrivateRoute path="/countries" component={Countries} />
              <PrivateRoute path="/reports" component={Reports} />
              <PrivateRoute path="/settings" component={Settings} />
              <PrivateRoute path="/settings/faq" component={Faq} />
            </Switch>
          </>
        </Router>
      </AuthContext.Provider>
    </ErrorContext.Provider>
  );
};

export default Root;